export const environment = {
  production: false,
  version: '25.0718.220000',
  maxTabs: 12,
  appName: 'Risk Platform',
  languages: {
    'de': 'Deutsch',
    'en': 'English'
  },
  GoogleMaps: {
    // ApiKey: 'AIzaSyCYsiLlG_pXNPzWLWmU9OUQQuFhgyYX-D8'
    ApiKey: 'AIzaSyCxTawWMgt6eBIQkhLK7Xd-31FlhhNgHzs'
  },
  sec: {
    mainToken: 'APPUSE',
    appID: 32,
    domain: 'exconuser',
    user: {}
  },
  rest: {
    LoginUrl: 'https://www.myexcon.com/srv/sec/',
    // ServiceUrl: 'https://www.myexcon.com/srv/rima/riskplatform/',
    // ServiceUrl: 'http://localhost:54545/',
    ServiceUrl: 'https://www.myexcon.com/srv/rima/riskplatform/',
    Endpoints:
      {
        PlanningHQR_Summary: '{uid}/planninghq/{AuditYear}',
        PlanningHQR_List: '{uid}/planninghq/{AuditYear}/list',
        DealerR_List: '{uid}/dealer',
        DealerR_Summary: '{uid}/dealer/{DealerID}',
        DealerAuditR_List: '{uid}/dealer/{DealerID}/audit',
        DealerInventoryR_List: '{uid}/dealer/{DealerID}/currentStock',
        DealerU: '{uid}/dealer/{DealerID}',
        DealerU_Comment: '{uid}/dealer/{DealerID}/comment',
        DealerU_InternalComment: '{uid}/dealer/{DealerID}/internalcomment',
        DealerWhiteBlackListCU: '{uid}/dealer/WhiteBlackList',
        DealerPickableInventoryR_List: '{uid}/dealer/{DealerID}/pickableinventory/{Level}',
        DealerSuccessorC: '{uid}/dealer/{DealerID}/successor',
        AuditC: '{uid}/audit',
        PlanningHQAuditU_Move: '{uid}/planninghq/{AuditYear}/move/{AuditID}',
        PlanningHQAuditU_Edit: '{uid}/planninghq/{AuditYear}/edit/{AuditID}',
        PlanningHQAuditU_Cancel: '{uid}/planninghq/{AuditYear}/cancel/{AuditID}',
        PlanningHQAuditD: '{uid}/planninghq/{AuditYear}/delete/{AuditID}',
        PlanningHQAuditC: '{uid}/planninghq/{AuditYear}/create',
        PlanningHQExport: '{uid}/planninghq/{AuditYear}/export/{cult}',
        PlanningHQExportMonth: '{uid}/planninghq/{AuditYear}/{AuditMonth}/export',
        PlanningHQMonthApproval: '{uid}/planninghq/{AuditYear}/{AuditMonth}/approval',
        PlanningHQ2R_Summary: '{uid}/phq2/{AuditYear}',
        PlanningHQ2_SFS_R_Summary: '{uid}/phq2sfs/{AuditYear}',
        AuditR_Summary: '{uid}/audit/{AuditID}',
        AuditInventoryR_List: '{uid}/audit/{AuditID}/inventory',
        DefaultSettingsR_Summary: '{uid}/defaultsettings',
        KanbanR_Summary: '{uid}/kanban/{AuditYear}/{AuditMonth}',
        KanbanR_ListLane1: '{uid}/kanban/{AuditYear}/{AuditMonth}/1',
        KanbanR_ListLane2: '{uid}/kanban/{AuditYear}/{AuditMonth}/2',
        KanbanR_ListLane3: '{uid}/kanban/{AuditYear}/{AuditMonth}/3',
        KanbanR_ListLane4: '{uid}/kanban/{AuditYear}/{AuditMonth}/4',
        AuditR_Report: '{uid}/audit/{AuditID}/report',
        AuditU_Cancel: '{uid}/audit/{AuditID}/cancel',
        AuditU_Pin: '{uid}/audit/{AuditID}/pin',
        AuditU_Extend: '{uid}/audit/{AuditID}/extend',
        AuditU_Resend: '{uid}/audit/{AuditID}/resend',
        AuditU_Escalate: '{uid}/audit/{AuditID}/escalate',
        AuditU_Archive: '{uid}/audit/{AuditID}/archive',
        AuditU_EscalationAction: '{uid}/audit/{AuditID}/escalationaction',
        AuditU_RemoteClose: '{uid}/audit/{AuditID}/remoteclose',
        AuditU_ApplyResults: '{uid}/audit/{AuditID}/TransferPartialResult',
        AuditU_ScComment: '{uid}/audit/{AuditID}/sccomment',
        AuditU_Reopen: '{uid}/audit/{AuditID}/reopen',
        AuditU_AuditMdtComment: '{uid}/audit/{AuditID}/AuditMdtComment',
        AuditAttachmentR_List: '{uid}/audit/{FKID}/attachments',
        AuditAttachment: '{uid}/attachment/{ID}',
        AuditAttachmentR: '{uid}/attachment/{ID}',
        AuditAttachmentC: '{uid}/attachment/{FKID}',
        AuditAttachmentD: '{uid}/attachment',
        InventoryR_Summary: '{uid}/audit/{auditId}/inventory/{InventoryID}',
        InventoryHistoryR_List: '{uid}/audit/{auditId}/inventory/{InventoryID}/history',
        InventoryAttachmentR_List: '{uid}/audit/{auditId}/inventory/{InventoryID}/attachments',
        InventoryAttachment: '{uid}/attachment/{ID}',
        InventoryAttachmentR: '{uid}/attachment/{ID}',
        InventoryAttachmentC: '{uid}/attachment/{FKID}',
        InventoryAttachmentD: '{uid}/attachment',
        AuditReviewR_Summary: '{uid}/auditreview/{AuditID}',
        AuditReviewInventoryR_List: '{uid}/auditreview/{AuditID}/inventory',
        AuditReviewCommentR_List: '{uid}/auditreview/{AuditID}/comment',
        AuditReviewItemR_Summary: '{uid}/auditreview/{AuditID}/inventory/{InventoryID}',
        AuditReviewItemU_Clear: '{uid}/auditreview/{AuditID}/inventory/{InventoryID}',
        AuditReviewItemImageU_Checked: '{uid}/auditreview/{AuditID}/inventory/{InventoryID}/image/{ImageID}',
        ReviewR_ListOpen: '{uid}/reviewopen',
        ReviewR_List: '{uid}/review',
        ReviewEditorR_List: '{uid}/revieweditor',
        ReviewU_Assign: '{uid}/reviewassign/{EditorID}',
        ReviewU_Finish: '{uid}/auditreview/{AuditID}',
        ReviewAttachmentR: '{uid}/auditreview/{AuditID}/inventory/{InventoryID}/attachment/{AttachmentID}',
        ReviewAttachmentU_Clear: '{uid}/auditreview/{AuditID}/inventory/{InventoryID}/attachment/{AttachmentID}',
        ReviewItemImagesU_Clear: '{uid}/auditreview/{AuditID}/inventory/{InventoryID}/attachment',
        AuditR_PartialReview: '{uid}/audit/{AuditID}/partial',
        DataImportR_List: '{uid}/dataimport/{clientID}',
        DataImportR: '{uid}/dataimport/{ImportID}/{clientID}',
        DataImportTemplateR: '{uid}/dataimport/{ImportID}/template/{TemplateID}/{clientID}',
        DataImportU_Recipients: '{uid}/dataimport/{ImportID}',
        AuditC_Selfcheck: '{uid}/dealer/{DealerID}/selfcheck',
        AuditC_Floorcheck: '{uid}/dealer/{DealerID}/floorcheck',
        ClientR_List: '{uid}/client',
        ConfigR_List: '{uid}/clients/configuration/{clID}',
        ConfigR_Summary: '{uid}/configurations/{mandantID}',
        ConfigU: '{uid}/clients/{clID}/configuration/{rating}',
        ConfigAuditResultU: '{uid}/clients/{clID}/AuditResult/',
        ConfigReiewResultU: '{uid}/clients/{clID}/ReviewResult/',
        ConfigReiewResultD: '{uid}/clients/{clID}/ReviewResult/',
        ConfigReiewResultC: '{uid}/clients/{clID}/ReviewResult/',
        AuditInventoryR_Export: '{uid}/audit/{AuditID}/inventoryexport/{cult}/',
        Dashboard: '{uid}/dashboard',
        DashboardR_Schedule: '{uid}/dashboard/schedule/{day}',
        DashboardR_LandingStrip: '{uid}/dashboard/landingstrip',
        DispositionR_Summary: '{uid}/disposition',
        DispositionU: '{uid}/disposition',
        DispositionR_ListAudits: '{uid}/disposition/audit',
        DispositionR_ListAuditors: '{uid}/disposition/auditor',
        DispositionAuditR_ListAuditors: '{uid}/disposition/{AuditID}/auditor',
        AuditR_ProviderList: '{uid}/auditList/',
        AuditorR_ProviderList: '{uid}/auditorList/',
        AuditorU_ProviderAssign: '{uid}/audit/{AuditID}/dispose',
        AuditorU_ProviderPlan: '{uid}/audit/{AuditID}/plan',
        Provider_AuditU_Cancel: '{uid}/audit/{AuditID}/cancelAudit',
        Provider_ClientContactR_List: '{uid}/audit/{AuditID}/clientContactList',
        Provider_AuditU: '{uid}/audit/{AuditID}/editAudit',
        DealerLocationC: '{uid}/dealer/{DealerID}/Location',
        DealerLocationU: '{uid}/dealer/{DealerID}/Location',
        DealerLocationD: '{uid}/dealer/{DealerID}/Location/{LocationID}',
        DealerLocationR_List: '{uid}/dealer/{DealerID}/Location',
        DealerGeofenceR_List: '{uid}/dealer/{DealerID}/Geofence',
        DealerGeofenceC: '{uid}/dealer/{DealerID}/Geofence',
        DealerGeofenceU: '{uid}/dealer/{DealerID}/Geofence/{gfID}',
        DealerGeofenceD: '{uid}/dealer/{DealerID}/Geofence/{gfID}',
        Provider_DealerR_List: '{uid}/dealer/provider',
        Provider_DealerU: '{uid}/dealer/provider/{DealerID}',
        Provider_DealerC: '{uid}/dealer/provider',
        Provider_AuditR_Summary: '{uid}/provider/audit/{AuditID}',
        ClientContactR_List: '{uid}/audit/{AuditID}/contact',
        Common_MeR_Summary: '{uid}/me',
        Provider_DashboardR_Summary: '{uid}/provider/dashboard',
        Common_MeReleaseNotesR: '{uid}/me/releasenotes/{riIndex}',
        AuditU_Selfcheck: '{uid}/audit/{AuditID}/selfcheck',
        AuditU_Floorcheck: '{uid}/audit/{AuditID}/floorcheck',
        ProviderConfig_AuditorR_List: '{uid}/clients/Auditors',
        ProviderConfig_AuditorU: '{uid}/clients/Auditors/{AuditorID}',
        ProviderConfig_AuditorC: '{uid}/clients/Auditors',
        ProviderConfig_AuditorD: '{uid}/clients/Auditors/{AuditorID}',
        Provider_ClientR_List: '{uid}/client/provider',
        Provider_AuditR_Export: '{uid}/config/exportAudit/{audityear}/{auditmonth}/{auditstatus}/{client}/{cult}/',
        Provider_DealerR_Export: '{uid}/config/exportDealer/{client}/{cult}/',
        DealerAuditR_export: '{uid}/dealer/{DealerID}/auditlistexport/{cult}/',
        AuditU_FollowupDate: '{uid}/audit/{AuditID}/followupdate',
        DealerHierarchyR_List: '{uid}/dealer/{DealerID}/hierarchy',
        ReviewGroupC: '{uid}/reviewgroup',
        ReviewGroupU: '{uid}/reviewgroup/{AuditGroup}',
        ReviewGroupD: '{uid}/reviewgroup/{AuditGroup}',
        ReviewGroupR_ListCandidates: '{uid}/reviewcandidates/{AuditID}',
        ReviewAuditR_List: '{uid}/review/{AuditID}/audit',
        ReviewGroupR_ListAllPossible: '{uid}/reviewallpossible',
        ReviewGroupR_List: '{uid}/reviewgroup/{AuditGroup}',
        ReviewGroupU_Edit: '{uid}/reviewgroup/{AuditGroup}/edit',
        ReviewGroupU_AuditAdd: '{uid}/reviewgroup/{AuditGroup}/add',
        ReviewGroupU_AuditDel: '{uid}/reviewgroup/{AuditGroup}/del',
        AuditPlanningR_Summary: '{uid}/auditplanning/{AuditYear}',
        AuditPlanningC: '{uid}/auditplanning/{AuditYear}',
        AuditPlanningD: '{uid}/auditplanning/{AuditYear}/{PlanID}',
        AuditReviewAttachmentR_List: '{uid}/review/{FKID}/attachment',
        AuditReviewAttachment: '{uid}/attachment/{ID}',
        AuditReviewAttachmentR: '{uid}/attachment/{ID}',
        AuditReviewAttachmentC: '{uid}/attachment/{FKID}',
        AuditReviewAttachmentD: '{uid}/attachment',
        AuditReviewItemAttachmentC: '{uid}/reviewitem/{InventoryID}/attachment',
        AuditReviewItemAttachmentD: '{uid}/reviewitem/{InventoryID}/attachment/{AttachmentID}',
        AuditReviewItemAttachmentR_List: '{uid}/reviewitem/{FKID}/attachment',
        Excon_ClientR_List: '{uid}/exc/client',
        Excon_ClientR_Summary: '{uid}/exc/client/{ClientID}',
        Excon_AuditR_List: '{uid}/exc/audit',
        Excon_AuditR_Summary: '{uid}/exc/audit/{AuditID}',
        Excon_DealerR_List: '{uid}/exc/dealer',
        Excon_DealerR_Summary: '{uid}/exc/dealer/{DealerID}',
        ReviewBalanceR_Summary: '{uid}/review/{AuditID}/balance',
        CalendarR_Summary: '{uid}/calendarview/{Year}/{Month}/{Country}',
        CalendarR_List: '{uid}/calendar/{Year}/{Month}/{Country}',
        CalendarWeekR_Summary: '{uid}/calendarweekview/{Year}/{Week}/{Country}',
        CalendarWeekR_List: '{uid}/calendarweek/{Year}/{Week}/{Country}',
        Provider_AuditU_BatchAssign: '{uid}/provider/auditassignbatch',
        ReportR_List: '{uid}/customreport',
        ReportR: '{uid}/customreport/{rptID}',
        ReportR_Template: '{uid}/customreport/{rptID}/template',
        SelfcheckConfigR_Summary: '{uid}/selfcheckconfig',
        ReportAboR_List: '{uid}/abo',
        ReportAbo_CU: '{uid}/abo',
        ReportAbo_D: '{uid}/abo/{rpaID}',
        SelfcheckConfig_Header_Post: '{uid}/selfcheckconfig',
        SelfcheckConfig_Sequence_Put: '{uid}/selfcheckconfig/sequence',
        SelfcheckConfig_Sequence_Post: '{uid}/selfcheckconfig/sequence/{seqID}',
        SelfcheckConfig_Sequence_Delete: '{uid}/selfcheckconfig/sequence/{seqID}',
        SelfcheckConfig_Step_Put: '{uid}/selfcheckconfig/step',
        SelfcheckConfig_Step_Post: '{uid}/selfcheckconfig/step/{ssID}',
        SelfcheckConfig_Step_Delete: '{uid}/selfcheckconfig/step/{ssID}',
        ReviewDoneR_List: '{uid}/reviewdone',
        AuditsPendingR_List: '{uid}/auditspending',
        ReviewU_Reopen: '{uid}/review/{AuditID}/reopen',
        AuditU_SetInventory: '{uid}/audit/{AuditID}/AuditInventory'
      }
  }
};
